import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.acc.production,
  name: sharedEnvironment.acc.name,
  returnUrl: sharedEnvironment.acc.enkatRegisterUrl,
  etjansterCommonUrl: sharedEnvironment.acc.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.acc.ansokanUrl,
  bpUrl: sharedEnvironment.acc.bpUrl,
  cookieDomain: sharedEnvironment.acc.cookieDomain,
  projektApiUrl: `${sharedEnvironment.acc.gatewayUrl}/projekt`,
  projektSignalRUrl: `${sharedEnvironment.acc.gatewayUrl}/projekt`,
  etjansterCommonApiUrl: `${sharedEnvironment.acc.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring/projekt`,
  sprakHanteringApiUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.acc.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.acc.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.acc.projektUrl,
  featureUrl: `${sharedEnvironment.acc.gatewayUrl}/projekt/feature`,
  externalLinks: sharedEnvironment.acc.externalLinks,
  baseGatewayUrl: sharedEnvironment.acc.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.acc.apimSubscriptionKey,
  chatbotApiUrl: `${sharedEnvironment.acc.gatewayUrl}/projekt/chatbot`,

  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.acc.gatewayUrl}/projekt`,
      sharedEnvironment.acc.azureAdB2C.clientId.projektClientId,
      sharedEnvironment.acc.azureAdB2C.clientId.projektApiClientId,
    ),
    authority: sharedEnvironment.acc.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.acc.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.acc.azureAdB2C.clientId.projektApiClientId}/all`,
    tenant: sharedEnvironment.acc.azureAdB2C.tenant,
    policies: sharedEnvironment.acc.azureAdB2C.policies,
    clientId: sharedEnvironment.acc.azureAdB2C.clientId,
    allowRedirectInIframe: true,
  },
  ga4MeasurementId: sharedEnvironment.acc.ga4MeasurementId,
};
